import axios from 'axios';
import instanceAxiosAWS from './axiosConfigAWS';


const getAttachment = (ConnectionToken, AttachmentId) => {
    instanceAxiosAWS.defaults.headers['x-amz-bearer'] = ConnectionToken;
    let request = {
        "AttachmentId": AttachmentId
     }
    return new Promise((resolve, reject) => {
        instanceAxiosAWS.post('/participant/attachment',request)
        .then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error);
        })
    })
}

const downloadAttachment = (url) => {
    return new Promise((resolve, reject) => {
        axios.get(url, {responseType : 'blob' }).then(res=>resolve(res)).catch(err=>reject(err));
    })
}


export {
     getAttachment, downloadAttachment
};